<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="classSection" slot-scope="classSection">
          <div>
            <div class="font-weight-bold">
              {{ classSection.class.name }} ({{
                classSection.section ? classSection.section.name : "All"
              }})
            </div>
          </div>
        </template>
        <template slot="name" slot-scope="name">
          <div class="text-wrap" style="width:80%">
            <div class="font-weight-bold ">{{ name }}</div>
          </div>
        </template>
        <!-- <template slot="description" slot-scope="description">
          <div class="text-wrap" style="width:150px">
            <div>{{ description }}</div>
          </div>
        </template> -->
        <template slot="exam_subjects" slot-scope="exam_subjects">
          <div class="text-wrap">
            <a-tag
              v-for="examSubject in exam_subjects"
              :key="examSubject.id"
              color="purple"
            >
              {{ examSubject.subject.abbreviation }}
            </a-tag>
          </div>
        </template>
        <template slot="date" slot-scope="date">
          <div>{{ moment(date).format(dateFormat) }}</div>
        </template>
        <template slot="start_time" slot-scope="start_time">
          <div>{{ moment(start_time, "HH:mm:ss").format(timeFormat) }}</div>
        </template>
        <template slot="end_time" slot-scope="end_time">
          <div>{{ moment(end_time, "HH:mm:ss").format(timeFormat) }}</div>
        </template>
        <template slot="duration" slot-scope="duration">
          <div>{{ duration }} mins</div>
        </template>
        <template slot="type" slot-scope="type">
          <div>{{ getExamTypeName(type) }}</div>
        </template>
        <template slot="status" slot-scope="status">
          <div class="font-weight-bold text-wrap">
            {{ onlineExamStatus[status].name }}
          </div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a-tooltip
              placement="top"
              title="Edit"
            >
              <a
              href="javascript:;" v-if="rolesetting.editable"
              class="btn btn-sm btn-light mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
            </a>
            </a-tooltip>

            <!-- Questions -->
            <a-tooltip
              placement="top"
              title="Question"
            >
            <a
              href="javascript:;" v-if="rolesetting.canviewquestion"
              :class="['btn btn-sm btn-success btn-with-addon mr-2']"
              @click="handleManageQuestion(record)"
            >
              <span class="btn-addon">
                <i :class="['btn-addon-icon fe fe-square']" />
              </span>
              Qs
            </a>
            </a-tooltip>
            <a-tooltip
              placement="top"
              title="Manage"
            >
            <!-- Manage -->
            <a
              href="javascript:;" v-if="rolesetting.candeclare || rolesetting.canundeclare"
              class="btn btn-sm btn-primary mr-2"
              @click="handleManageClick(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-settings" />
              </span>
            </a>
            </a-tooltip>
            <!-- Delete -->
            <a-tooltip
              placement="top"
              title="Delete"
            >
            <a
              href="javascript:;" v-if="rolesetting.deletable"
              class="btn btn-sm btn-danger"
              @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
            </a>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>
    <!-- Edit Form -->
    <edit-exam-setup />
  </div>
</template>
<script>
import moment from 'moment'
// import { onlineExamTypes, onlineExamStatus } from '@/services/globaldata'
import { onlineExamStatus } from '@/services/globaldata'
import EditExamSetup from '@/components/online-exam/exam/Forms/Edit/index'

const columns = [
  {
    title: 'Class (Sec)',
    className: 'text-left text-gray-6',
    key: 'classSection',
    scopedSlots: { customRender: 'classSection' },
  },
  {
    title: 'Name',
    dataIndex: 'name',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'name' },
    // sorter: (a, b) => a.name.length - b.name.length,
    // width: 50,
  },
  // {
  //   title: 'Description',
  //   dataIndex: 'description',
  //   scopedSlots: { customRender: 'description' },
  // },
  {
    title: 'Subjects',
    dataIndex: 'exam_subjects',
    scopedSlots: { customRender: 'exam_subjects' },
  },
  {
    title: 'Date',
    dataIndex: 'date',
    scopedSlots: { customRender: 'date' },
  },
  {
    title: 'Start',
    dataIndex: 'start_time',
    scopedSlots: { customRender: 'start_time' },
  },
  {
    title: 'End',
    dataIndex: 'end_time',
    scopedSlots: { customRender: 'end_time' },
  },
  {
    title: 'Duration',
    dataIndex: 'duration',
    scopedSlots: { customRender: 'duration' },
  },
  {
    title: 'Type',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'OnlineExamsTable',
  mounted: function() {
    this.getOnlineExams()
  },
  components: {
    EditExamSetup,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      onlineExamTypes: [],
      onlineExamStatus,
      columns,
      selectedRowKeys: [],
      dateFormat: 'DD-MM-YYYY',
      timeFormat: 'hh:mm a',
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    moment,
    getExamTypeName(id) {
      var data = this.onlineExamTypes.data.filter(obj => obj.id === id)
      if (data.length === 0) {
        return 'Not Found'
      } else {
        return Object.assign({}, ...data).name
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      this.$eventBus.$emit('openOnlineExamEditFormModal', record.id)
    },
    handleManageQuestion: function(record) {
      this.$router.push({
        name: 'onlineexamquestions',
        params: {
          pagepermission: this.rolesetting,
          examType: record.type,
          examId: record.id,
          classId: record.class_id,
          sectionId: record.section_id !== null ? record.section_id : null,
          questionWiseMark: record.questionwise_mark,
        },
      })
    },
    handleManageClick: function (record) {
      // console.log(record)
      this.$router.push({ name: 'onlineexamresult', params: { pagepermission: this.rolesetting, examId: record.id, classId: this.data[0].class_id, sectionId: this.data[0].section_id, statusId: record.status } })
    },
    getOnlineExams() {
      // console.log('test online exam : ', this.data)
      this.$http
        .get('/api/online-exam/examtype/all')
        .then((response) => {
          this.onlineExamTypes = response.data
        // this.loading = false
        })
        .catch(error => {
          this.$nprogress.done()
          this.$neoNotify.error(error)
        })
    },
    onDelete: function(record) {
      // this.getOnlineExams()
      this.$confirm({
        title: 'Are you sure?',
        content: 'Click Yes to delete this online exam!',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/online-exam/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'Online exam has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
